import AddPripomienkaAdminPage from './AddPripomienkaAdminPage';

export default AddPripomienkaAdminPage;
